import React from "react";
import { connect } from "react-redux";
// import { addDays } from "date-fns";
import Loading from "./Loading";
import { getLoginUser } from "../actions";

import Login from "./Login";
import Operation from "../social-operation/components/operation";
import AnswersConfigPage from "../social-predef-answers/components/predef-answers";
import Home from "./Home";
import { OPERATION_USER_ROLE } from "../social-operation/configs/operation-ui";

class Main extends React.Component<any> {
  state = {
    isShowLoading: true,
  };

  componentDidMount() {
    // console.log(this.props.currentPage);
    this.props.getLoginUser();
  }
  componentDidUpdate(prevProps: any) {
    if (prevProps.loginUser !== this.props.loginUser) {
      let loginUser = this.props.loginUser
      if (this.props.loginUser.status !== "Initializing" && (loginUser.data && !loginUser.data.role)) {
        this.setState({ isShowLoading: false });
      }
    }
    // console.log(this.props.currentPage);
  }
  renderLoading = () => {
    if (this.state.isShowLoading) {
      return <Loading />;
    }
    return null;
  };
  showLoading = () => {
    this.setState({ isShowLoading: true });
  };
  hideLoading = () => {
    this.setState({ isShowLoading: false });
  };
  renderContent = () => {
    if (this.props.loginUser.status !== "Initializing") {
      if (this.props.loginUser.data) {
        const userRole = this.props.loginUser.data.role;
        switch (this.props.currentPage) {
          case "Home":
            if (userRole) {
              return (
                <Operation
                  showLoading={this.showLoading}
                  hideLoading={this.hideLoading}
                />
              );
            }
            return (
              <Home
                showLoading={this.showLoading}
                hideLoading={this.hideLoading}
              />
            );
          case "Operation":
            return (
              <Operation
                showLoading={this.showLoading}
                hideLoading={this.hideLoading}
              />
          );
          case "AnswersConfig":
            if (userRole === OPERATION_USER_ROLE.SUPERVISOR.id) {
              return (
                <AnswersConfigPage
                  showLoading={this.showLoading}
                  hideLoading={this.hideLoading}
                />
              );
            }
            break;
          default:
            break;
        }
      } else {
        return <Login></Login>;
      }
    } else {
      return null;
    }
  };

  render() {
    // console.log(this.props.loginUser);
    return (
      <div
        style={{ overflow: "auto", width: "100%", height: "100vh" }}
        id="renderContainer"
      >
        {this.renderLoading()}
        {this.renderContent()}
      </div>
    );
  }
}

const mapStateToProps = (states: any) => {
  return {
    currentPage: states.page.currentPage,
    loginUser: states.loginUser,
  };
};
export default connect(mapStateToProps, { getLoginUser })(Main);
